import workspaceQuery from 'graphql/queries/customer/CustomerContactAttributeConfigWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/customer/CustomerContactAttributeConfigListQuery.graphql';
import instanceQuery from 'graphql/queries/customer/CustomerContactAttributeConfigQuery.graphql';
import defaultQuery from 'graphql/queries/customer/CustomerContactAttributeConfigDefault.graphql';
import mutationQuery from 'graphql/mutations/customer/CustomerContactAttributeConfigMutation.graphql';
import fragment from 'graphql/fragments/customer/CustomerContactAttributeConfigFragment.graphql';

const CustomerContactAttributeConfig = {
  type: 'CustomerContactAttributeConfig',
  title: 'Customer Contact Attributes',
  formTitle: 'Customer Contact Attribute',
  formUrl: '/Customers/ContactAttributeConfig/Details/',
  workspaceUrl: '/Customers/ContactAttributeConfig/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  list: listQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'title',
  },
  fragment,
  screenReference: 'CUSTOMER_CONTACT_ATTRIBUTES',
};

export default CustomerContactAttributeConfig;
